module.exports = __webpack_public_path__ + "static/img/wxcode.c5054747.png";